import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    radioButton: {
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 5
    },
    outerRadioCircle: {
        width: 24,
        height: 24,
        borderRadius: 12,
        borderWidth: 2,
        borderColor: 'rgb(255, 198, 70)',
        marginRight: 10,
        justifyContent: 'center',
        alignItems: 'center'
    },
    innerRadioCircle: {
        width: 12,
        height: 12,
        borderRadius: 10,
        borderColor: 'white'
    }
});
